import React from 'react'
import {
  Box,
  Button,
  Card,
  CardBody,
  CardHeader,
  Collapse,
  Flex,
  Heading,
  SimpleGrid,
  Text
} from '@chakra-ui/react'
import StatCard from './StatCard'
import { CoinData } from '../types'

interface HistoryPanelProps {
  data: CoinData
  descriptionRef: React.RefObject<HTMLDivElement>
  isDescriptionOpen: boolean
  onDescriptionToggle: () => void
  gridTemplateColumns?: number | undefined
  statCardBg: string
  cardBg: string
  accentColor: string
}

const HistoryPanel = ({ 
  data, 
  gridTemplateColumns, 
  statCardBg, 
  cardBg, 
  accentColor,
  isDescriptionOpen,
  onDescriptionToggle,
  descriptionRef
}: HistoryPanelProps) => (
  <>
    <SimpleGrid columns={gridTemplateColumns || 1} spacing={4} mb={6}>
      <StatCard
        bg={statCardBg}
        label="Hashing Algorithm"
        value={data.hashing_algorithm || 'N/A'}
      />

      <StatCard
        bg={statCardBg}
        label="Genesis Date"
        value={data.genesis_date ? new Date(data.genesis_date).toLocaleDateString() : 'N/A'}
      />
    </SimpleGrid>

    <Card bg={cardBg} mb={6}>
      <CardHeader>
        <Flex justify="space-between" align="center">
          <Heading size="md">About {data.name}</Heading>
          <Button size="sm" onClick={onDescriptionToggle}>
            {isDescriptionOpen ? 'Show Less' : 'Show More'}
          </Button>
        </Flex>
      </CardHeader>
      <CardBody>
        <Collapse in={isDescriptionOpen} animateOpacity>
          <Box
            ref={descriptionRef}
            dangerouslySetInnerHTML={{ __html: data.description.en }}
            sx={{
              '& a': { color: accentColor },
              '& p': { mb: 4 }
            }}
          />
        </Collapse>
        {!isDescriptionOpen && (
          <Text noOfLines={3} dangerouslySetInnerHTML={{ __html: data.description.en }} />
        )}
      </CardBody>
    </Card>
  </>
)

export default HistoryPanel
